class Queue {
   constructor(maxSize = 3) {
      this.elements = [];
      this.maxSize = maxSize;
   }
  
  getElements() {
    return this.elements;
  }
   
   enqueue(node) {
     if(this.elements.length == this.maxSize) { 
       this.elements.shift();
       this.elements.push(node);
     }
     else {
      this.elements.push(node);
     }
   }
 
   dequeue() {
      if(this.elements.length > 0) { 
          return this.elements.shift();
      } else {
          return 'Underflow situation';
      }
   }
   isEmpty() {
      return this.elements.length == 0;
   }
   
   front() {
      if(this.elements.length > 0) {
          return this.elements[0];
      } else {
          return "The Queue is empty!";
      }
   }
   print() {
      return this.elements;
   }
  array() {
    return { 'items': this.elements};
  }
  length() {
    return this.elements.length;
  }
  clear() {
   this.elements = [];
}
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  let formData = {
    'items': []
  };
  
  // Get bundle size from data attribute or default to 3
  const bundleSizeElement = document.querySelector('[data-bundle-size]');
  const bundleSize = bundleSizeElement ? parseInt(bundleSizeElement.dataset.bundleSize) : 3;
  const queue = new Queue(bundleSize);

  // Add to bundle button click handler
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('byob-add-button')) {
      queue.enqueue({
        "id": e.target.dataset.variant, 
        "quantity": 1, 
        "price": e.target.dataset.price, 
        "title": e.target.dataset.title,
        "img": e.target.dataset.img
      });
      showBundleSelection(queue);
    }
  });

  // Clear bundle button click handler
  document.addEventListener('click', function(e) {
    if (e.target.id === 'ext-byob-reset') {
      queue.clear();
      showBundleSelection(queue);
    }
  });

  // Add to cart button click handler
  document.addEventListener('click', function(e) {
    if (e.target.id === 'ext-add-bundle') {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(queue.array())
      })
      .then(response => {
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
      
      // Get promo code from data attribute or default to BYOB
      const promoCodeElement = document.querySelector('[data-promo-code]');
      const promoCode = promoCodeElement ? promoCodeElement.dataset.promoCode : 'BYOB';
      location.href = "/discount/" + promoCode + "?redirect=%2Fcart";
    }
  });

  function showBundleSelection(queue) {
    const selectedProducts = document.getElementsByClassName("bundle-builder__item");
    if(queue.isEmpty()) {
      for (let i = 0; i < selectedProducts.length; i++) {
        selectedProducts[i].getElementsByClassName("byob-image")[0].src = 'https://cdn.shopify.com/s/files/1/0504/8129/9637/files/cp-bg.jpg';
        selectedProducts[i].getElementsByClassName("byob-title")[0].innerHTML = '';
      }
    } else {
      for (let i = 0; i < queue.length(); i++) {
        selectedProducts[i].getElementsByClassName("byob-image")[0].src = queue.getElements()[i].img;
        selectedProducts[i].getElementsByClassName("byob-title")[0].innerHTML = queue.getElements()[i].title;
      }
    }
  }
});
